import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CockpitState, COCKPIT_TAG } from './cockpit.state';

const CockpitSelector = createFeatureSelector<CockpitState>(COCKPIT_TAG);

export const getCockpitCommunications = createSelector(CockpitSelector, (state: CockpitState) => state?.communications);
